import type { AgentWidgetSettings } from '../../../api';

export const getDefaultSettingsValue = (
  properties: Record<string, { default?: unknown }>
): AgentWidgetSettings => {
  const defaultData: Partial<AgentWidgetSettings> = {};

  for (const [key, value] of Object.entries(properties)) {
    if (value.default !== undefined) {
      (defaultData as Record<string, unknown>)[key] = value.default;
    }
  }

  return {
    ...defaultData,
  };
};
